// extracted by mini-css-extract-plugin
module.exports = {"overAll":"unlockloadermodal_overAll__1g0R5","textStyle":"unlockloadermodal_textStyle__2O3pj"};